module.exports = __webpack_public_path__ + "assets/img/246301.145604f6.png";